import { render, staticRenderFns } from "./DolchDynamite.vue?vue&type=template&id=5aa63206&scoped=true&"
import script from "./DolchDynamite.vue?vue&type=script&lang=js&"
export * from "./DolchDynamite.vue?vue&type=script&lang=js&"
import style0 from "./DolchDynamite.vue?vue&type=style&index=0&id=5aa63206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa63206",
  null
  
)

export default component.exports